
import { Box, useMediaQuery } from '@mui/material';
import React from 'react';
import HumbeeLogo from '../../../v2/TopNav/HumbeeLogo';

const AuthCardContainer = ({ children, showLogo = true }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  return (
    <Box sx={{ display: 'flex', 
      justifyContent: 'center', 
      minHeight: { xs: '100vh', md: '100vh' },
      alignItems: { xs: 'start', md:'center' },
      justifyContent: { xs: 'center', md: 'center' },
    }}>
      <Box sx={{ width: { xs:'100%', md:'500px'}, position: 'relative', 
        py: { xs: 8  , md:4 },
        px: { xs: 2  , md:4 },
        scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' }}}>
        <Box
          sx={{
            width: {xs:'100%' ,md:'500px'},
            height: { xs: '100vh', md: '100%' },
            position: 'absolute',
            top: -1,
            left: 0,
            borderRadius: 2,
            background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.05) 100%)',
            backgroundBlendMode: 'overlay',
            zIndex: 0,
            opacity: 0.6,
            border: '.5px solid rgba(255,255,255, 0.2)',
          }}
        />
        <Box
          sx={{
            width: {xs:'100%' ,md:'500px'},
            height: { xs: '100vh', md: '100%' },
            position: 'absolute',
            top: 0,
            left: 0,
            borderRadius: { md:2 },
            backgroundColor: !isMobile ? 'rgba(0, 0, 0, 0)' : 'rgba(0, 0, 0, 0)',
            backdropFilter: {xs: 'blur(2px)', md: 'blur(5px)'},
            WebkitBackdropFilter: {xs: 'blur(2px)', md: 'blur(5px)'},
            boxShadow: `
              inset 1px 1px 4px 0px rgba(255, 255, 255, 0.6),
              inset 1px 1px 0px 0px rgba(255, 255, 255, 1),
              inset 10px 0px 20px 0px rgba(0, 0, 0, 0.05),
              inset 1px 4px 40px 1px rgba(255, 255, 255, 1),
              inset 0px 2px 16px 1px rgba(255, 255, 255, 1),
              inset 0px -2px 0px 0px rgba(255, 255, 255, 1),
              inset -1px -4px 16px 0px rgba(255, 255, 255, 0.8)
            `,
            zIndex: 1,
          }}
        />
        <Box>
          <Box sx={{ display:"flex",flexDirection:"column", gap: 8, zIndex: 2, position: 'relative' }}>
            {showLogo && (
              <Box sx={{ display:"flex", alignItems:"center", justifyContent: 'center' }}>
                <HumbeeLogo width={200}/>
              </Box>
            )}
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AuthCardContainer;